import {
    IAccommodation,
    IAccommodationData
} from './index'
import {
    Criterion,
} from '../../abstract'

export class Accommodation extends Criterion<string> implements IAccommodation {
    constructor (data?: IAccommodationData) {
        super(data)
        // own assignments
    }

    validate(): boolean {
        return super.validate()
    }
}